import React, { useContext } from "react";
import {
  ListItem as GroupListItem,
  ListItemAvatar,
  ListItemButton as GroupListItemContent,
  ListItemText as GroupName,
} from "@mui/material";
import DisplayAvatarImage from "../../common/DisplayAvatarImage";
import {
  AddMembersContext,
  IAddMembersContext,
  SelectedUserType,
} from "hhn-commons";
import { INonPatientGroupData } from "@home-health-notify/domain";
import ButtonAdd from "../addUsers/actionButtons/ButtonAdd";

type AddGroupListItemProps = {
  chatGroup: INonPatientGroupData;
};

const AddGroupListItem = ({ chatGroup }: AddGroupListItemProps) => {
  const { selectedUsers, onAddGroup }: IAddMembersContext =
    useContext(AddMembersContext);

  const isSelected = selectedUsers.some(
    (user: SelectedUserType) => user.id === chatGroup.id,
  );

  return (
    <GroupListItem
      data-testid="add-group-list-item"
      disablePadding
      secondaryAction={
        <ButtonAdd
          isSelected={isSelected}
          onClick={() => onAddGroup(chatGroup.id, chatGroup.name)}
        />
      }
    >
      <GroupListItemContent
        disableRipple
        disableTouchRipple
        sx={{ cursor: "default" }}
      >
        <ListItemAvatar>
          <DisplayAvatarImage src={chatGroup.image} alt={chatGroup.name} />
        </ListItemAvatar>
        <GroupName primary={chatGroup.name} />
      </GroupListItemContent>
    </GroupListItem>
  );
};

export default AddGroupListItem;
